import { ReactElement } from 'react';
import { Container } from '@mui/material';

import { useConnection } from 'modules/auth/hooks/useConnection';

import { Details } from '../Details';
import { Forms } from '../Forms';
import { Intro } from '../Intro';
import { Stats } from '../Stats';
import { useStyles } from './useStyles';

export function Staking(): ReactElement {
  const { isConnected } = useConnection();
  const { classes } = useStyles();

  return (
    <Container className={classes.root}>
      {isConnected ? <Stats /> : <Intro />}

      <div className={classes.content}>
        <Forms />

        <Details />
      </div>
    </Container>
  );
}
